/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {ModelProperty} from '../../engine/model-property';
import {IEntity} from '../../interface/IEntity';
import {ChartEntity} from './chart-entity';

export class ChartUtil {

  static convertToDataset(data: IEntity[], property: ModelProperty): IEntity[] {
    const entities: IEntity[] = [];
    for (const item of data) {
      const d = entities.find(e => e.getLabel() === item[property.id]);
      if (d) {
        ++d[property.id];
      } else {
        const entity = new ChartEntity(item[property.id]);
        entity[property.id] = 1;
        entities.push(entity);
      }
    }
    return entities;
  }
}
